import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * Directive pour la gestion du scroll 2D type cliquer-déplacer
 */
@Directive({
    selector: '[dynamicDragScroll]'
})
export class DynamicDragScrollDirective implements OnInit {
    /** Activation ou non de la fonctionnalité */
    @Input() isDynamicDragScrollEnable = false;

    /** Déplacement en cours */
    private isDragging = false;

    /** Position de départ */
    private startX = 0;
    private startY = 0;

    /** Mesures du déplacement en cours */
    private scrollLeft = 0;
    private scrollTop = 0;

    /**
     * Constructeur
     */
    constructor(private el: ElementRef,private renderer: Renderer2) {}

    /**
     * Initialisation de la directive
     */
    ngOnInit() {
        //Si la directive est activée
        if (this.isDynamicDragScrollEnable) {
            //Application de la classe CSS correspondante
            this.renderer.addClass(this.el.nativeElement, 'dynamic-scroll');
        }
    }

    /**
     * Clic
     */
    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent): void {
        //Annulation si directive inactive ou clic droit
        if (!this.isDynamicDragScrollEnable || event.button !== 0) return;

        //Déplacement en cours
        this.isDragging = true;

        //Position de départ
        this.startX = event.clientX;
        this.startY = event.clientY;

        //Mesures du déplacement en cours
        this.scrollLeft = window.scrollX;
        this.scrollTop = window.scrollY;

        //Application de la classe CSS indiquant le déplacement en cours
        this.el.nativeElement.classList.add('dragging');
    }

    /**
     * Mouvement
     */
    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent): void {
        //Annulation si aucun mouvement en cours
        if (!this.isDragging) return;

        //Calcul du scroll horizontal et vertical
        const x = event.clientX - this.startX;
        const y = event.clientY - this.startY;

        //Application du scroll
        window.scrollTo(this.scrollLeft - x, this.scrollTop - y);
    }

    /**
     * Relâchement du clic
     */
    @HostListener('window:mouseup', ['$event'])
    onWindowMouseUp(event: MouseEvent): void {
        //Si un déplacement est en cours
        if (this.isDragging) {
            //Déplacement terminé
            this.isDragging = false;

            //Suppression de la classe CSS indiquant le déplacement en cours
            this.el.nativeElement.classList.remove('dragging');
        }
    }
}
